import { render } from "./GridDisplay.vue?vue&type=template&id=0c48fa9a"
import script from "./GridDisplay.vue?vue&type=script&lang=js"
export * from "./GridDisplay.vue?vue&type=script&lang=js"

import "./GridDisplay.vue?vue&type=style&index=0&id=0c48fa9a&lang=scss"

import exportComponent from "/Users/nigomatulin/projects/WOPA/tverstroyka/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__